module.exports = __webpack_public_path__ + "static/media/day.ee3386ef.svg";